<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">عنوان الاخبار</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "newsForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                        
                              <div class="col-12 mb-3">
                                <label for="">اظهار في الصفحة الرئيسية</label>
                                <div>
                                      <label class="switch">
                                    <input type="checkbox" id="inactive" (change)="inactiveChange()" [checked]="inactive == true"  />
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              

                            </div>
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> عنوان الخبر</label>
                                <input class="form-control"  id="validation01" type="text" formControlName="titleAr"
                                [tooltip]="fc.titleAr.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.titleAr.valid && (fc.titleAr.touched)"
                                [class.is-invalid]="fc.titleAr.invalid && (fc.titleAr.touched)"
                             
                                     required
                                     placeholder="عنوان الخبر"
                                    containerClass="" />
                            </div>
                            <!-- <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> عنوان الخبر باللغه الانجليزية</label>
                                <input class="form-control" appDisableWeritingArabic id="validation01" type="text" formControlName="title"
                                [tooltip]="fc.title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                             
                                     required
                                     placeholder="عنوان الخبر باللغه الانجليزية"
                                    containerClass="" />
                            </div> -->
                            <div class="col-lg-6 col-sm-12  mb-3" style="margin-top: 7px;">
                                <label for="">المحافظة</label>
                                <div class="form-group">
                                    <ng-multiselect-dropdown
                                    formControlName="GovernatesIds"
                                    [placeholder]="'اختر المحافظة  '"
                                    [settings]="dropdownSettings"
                                    [data]="Governates"
                                    [(ngModel)]="selectedItemsGovernates">
                                              </ng-multiselect-dropdown>
                                </div>
                              </div> 
                            <!-- body  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> رابط الفيديو</label>
                                <input class="form-control" id="validation01" type="text" formControlName="videoUrl"
                                [tooltip]="fc.videoUrl.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.videoUrl.valid && (fc.videoUrl.touched)"
                                [class.is-invalid]="fc.videoUrl.invalid && (fc.videoUrl.touched)"
                             
                                     required
                                     placeholder="https://www.example.com"
                                    containerClass="" />
                            </div>
                                                                <!-- select keyword -->
                     <div class="col-lg-6 col-sm-12  mb-3" style="margin-top: 7px;">
                        <label for="validationCustom06"> كلمات دليلية</label>
                        <ng-multiselect-dropdown
                               formControlName="keywords"
                               [placeholder]="'اختر كلمة  '"
                               [settings]="dropdownSettings"
                               [data]="keyword"
                               [(ngModel)]="selectedItems"
                               (onDeSelect)="onItemDeSelect($event)"
                               (onDeSelectAll)="onUnSelectAll($event)"
                               (onSelect)="onItemSelect($event)"
                               (onSelectAll)="onSelectAll($event)">
                                         </ng-multiselect-dropdown>
                    </div>
                    <div class="col-6 mb-3">
                        <label for="validation03"><span class="validation-required">*</span> التاريخ</label>
                        <input class="form-control" id="validation03" type="date" formControlName="date"
                        [tooltip]="fc.date.errors?.required ? 'الحقل مطلوب' : null"
                        [class.is-valid]="fc.date.valid && (fc.date.touched)"
                        [class.is-invalid]="fc.date.invalid && (fc.date.touched)"
                             required
                             appDisableWeritingArabic
                             placeholder=""
                            containerClass="" 
                            />
                    </div>
                   
  
</div>
 <!-- المحتوى       -->
 <div class="col-12 mb-3 px-0">
    <label for="validation03"><span class="validation-required">*</span> المحتوى</label>
<angular-editor  [placeholder]="'بالرجاء كتابة المحتوى هنا.....'" [config]="editorConfig" 
formControlName="bodyAr"></angular-editor>
</div>
<!-- <div class="col-12 mb-3 px-0">
    <label for="validation03"><span class="validation-required">*</span> المحتوى باللغه الانجليزية</label>
<angular-editor appDisableWeritingArabic [placeholder]="'بالرجاء كتابة المحتوى باللغه الانجليزية هنا.....'" [config]="editorConfig" 
formControlName="body"></angular-editor>
</div> -->
              <!-- to insert image  -->
              <div class="col-6 my-3 " >
                <img  src="{{ imageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
               <input type="file" formControlName="branchImage" accept="image/*" #file id="getLogo"
                style="display: none" (change)="getLogoUrl($event)" />
            <button type="button" onclick="document.getElementById('getLogo').click()"
                class="btn   d-block"  style="width: 60%;">
                ارفاق صورة
            </button>    
                        </div>
                
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn  pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

